import React, { useState } from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import Slider from "react-slick"; // Import the Slider component from react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const RelatedPosts = ({ posts, authorPosts }) => {
  const [activeTab, setActiveTab] = useState("related"); // State to handle active tab

  // Custom Arrow Components for slider
  const CustomPrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute top-1/2 left-2 transform -translate-y-1/2 z-10 bg-gray-500 p-2 rounded-full shadow-md hover:bg-gray-700"
    >
      <ArrowLeftIcon className="w-5 h-5 text-white" />
    </button>
  );

  const CustomNextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute top-1/2 right-2 transform -translate-y-1/2 z-10 bg-gray-500 p-2 rounded-full shadow-md hover:bg-gray-700"
    >
      <ArrowRightIcon className="w-5 h-5 text-white" />
    </button>
  );

  // Slider settings for related posts
  const relatedSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  // Slider settings for "More from the Author"
  const authorSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="related-posts-container py-10 mx-4 md:mx-36 max-w-7xl">
      <div className="td-related-title mb-4">
        <ul className="flex space-x-4">
          <li>
            <button
              onClick={() => setActiveTab("related")}
              className={`${
                activeTab === "related"
                  ? "text-gray-500 border-b-2 border-gray-500"
                  : "text-gray-500"
              } cursor-pointer hover:text-gray-800 py-2 px-4`}
            >
              Related posts
            </button>
          </li>
          <li>
            <button
              onClick={() => setActiveTab("author")}
              className={`${
                activeTab === "author"
                  ? "text-gray-500 border-b-2 border-gray-500"
                  : "text-gray-500"
              } cursor-pointer hover:text-gray-800 py-2 px-4`}
            >
              More from the author
            </button>
          </li>
        </ul>
      </div>

      {activeTab === "related" && (
        <Slider {...relatedSliderSettings}>
          {posts.map((post, index) => (
            <div key={index} className="p-4">
              <div className="shadow-lg rounded-md overflow-hidden">
                <a href={post.link}>
                  <img
                    src={
                      post?.featuredImage
                        ? `${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`
                        : "/placeholder.jpg"
                    }
                    alt={post.title}
                    className="w-full h-48 object-cover"
                  />
                </a>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-700">
                    <a href={post.link} className="hover:text-blue-500">
                      {post.title}
                    </a>
                  </h3>
                  <p className="text-sm text-gray-500">
                    {post.author} -{" "}
                    {new Date(post.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      )}

      {activeTab === "author" && (
        <Slider {...authorSliderSettings}>
          {authorPosts.map((post, index) => (
            <div key={index} className="p-4">
              <div className="shadow-lg rounded-md overflow-hidden">
                <a href={post.link}>
                  <img
                    src={post.featuredImage}
                    alt={post.title}
                    className="w-full h-48 object-cover"
                  />
                </a>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-700">
                    <a href={post.link} className="hover:text-blue-500">
                      {post.title}
                    </a>
                  </h3>
                  <p className="text-sm text-gray-500">
                    {post.author} -{" "}
                    {new Date(post.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default RelatedPosts;
